import { useEffect, useMemo, useState } from "react";
import useBreakpoint from "./useBreakpoint";

export enum ScreenSize {
  Mobile,
  Tab,
  Desktop,
}

export const useScreenSize = () => {
  const breakpoint = useBreakpoint();
  const [screenSize, setScreenSize] = useState<ScreenSize>(ScreenSize.Desktop);

  const out = useMemo(() => ({
    isMobile: screenSize === ScreenSize.Mobile,
    isTab: screenSize === ScreenSize.Tab,
    isDesktop: screenSize === ScreenSize.Desktop,
    isMobileOrTab: [ScreenSize.Mobile, ScreenSize.Tab].includes(screenSize),
    isTabOrDesktop: [ScreenSize.Tab, ScreenSize.Desktop].includes(screenSize)
  }), [screenSize]);

  useEffect(() => {
    if(["xs"].includes(breakpoint)) {
      setScreenSize(ScreenSize.Mobile);
    }
    else if(["sm"].includes(breakpoint)) {
      setScreenSize(ScreenSize.Tab); 
    }
    else {
      setScreenSize(ScreenSize.Desktop);
    }
  }, [breakpoint])

  return out;
}

export default useScreenSize;